import { makeStyles } from '@material-ui/core/styles';

export const useArchiveStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        backgroundColor: "#fff",
        margin: 0,
      },
      a: {
        textDecoration: 'none',
        color: '#9334ff',
        cursor: 'hand'
      }
    },
    root: {
      flexGrow: 1,
    },
    list: {
      lineHeight: '1.5',
      margin: 0,
      paddingLeft: 15,
      color: '#8c8c8c',
      '& li': {
        padding: '0 0 20px',
      },
    },
    innerList: {
      padding: '10px 24px',
      '& li': {
        fontSize: 'small',
      },
      '& li:last-child': {
        padding: 0,
      }
    },
    bodyPaper: {
      color: '#000',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    step: {
      marginBottom: '30px',
      '& .header': {
        marginBottom: 14
      },
      '& .body': {
        color: '#8c8c8c'
      }
    },
    inPageNavigation: {
      '& Button': {
        [theme.breakpoints.down('sm')]: {
          width: '100%'
        },
      },
    },
    pagination: {
      '& li button': {
        color: '#333'
      }
    },
    accordion: {
      background: 'none',
      boxShadow: 'none',
      borderRadius: '0 !important',
      color: 'black'
    },
    dFlex: {
      display: 'flex'
    },
    justifyContentEnd: {
      justifyContent: 'flex-end'
    },
    inputColor: {
      color: '#9334ff !important'
    },
    itemImage: {
      display: 'flex',
      justifyContent: 'center',
      padding: '15px',
      '& img': {
        borderRadius: '5px'
      }
    },
    paper: {
      background: 'white',
      boxShadow: '0px 0px 5px 1px rgb(0 0 0 / 20%)'
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    formControl: {
      color: '#000',
      margin: theme.spacing(1),
      minWidth: 120,
      '& :before': {
        borderBottom: '1px solid #000'
      }
    },
    selectEmpty: {
      color: '#000',
      marginTop: theme.spacing(2),
    },
}));
